import React from 'react'

import { Box } from '@material-ui/core'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import { Text } from '../'

import useTrailStep from 'hooks/useTrailStep'
import { RoundedButton } from 'components'
import { routes } from 'Routes'

const Conclusion = () => {
  const { hasBanner, jumpedToConclusion, handleNext } = useTrailStep()

  const history = useHistory()

  const redirectToCookies = () => {
    history.push(routes.cookies.banners)
  }

  return (
    <>
      <Text color="primary" fontSize="7vh" variant="h2">
        Você concluiu a jornada de configuração do seu canal de comunicação!
      </Text>
      <Box mt={3} mb={6}>
        {hasBanner || jumpedToConclusion ? (
          <Text fontSize="3vh" variant="h5" gutterBottom>
            Não se esqueça de divulgar o seu canal de comunicação! Essa é uma
            das etapas fundamentais do seu processo de adequação.
          </Text>
        ) : (
          <Text fontSize="3vh" variant="h5" gutterBottom>
            Seu banner de cookies já foi criado! Agora, é só finalizar a
            configuração. Clique em “Configurar Cookies” para continuar ou
            depois acesse o menu “Banner de Cookies”.
          </Text>
        )}
      </Box>

      <Box my={4} display="flex" alignItems="center">
        {!hasBanner && !jumpedToConclusion ? (
          <>
            <RoundedButton
              variant="outlined"
              withPadding
              onClick={() => handleNext()}
            >
              Finalizar
            </RoundedButton>
            <Box ml={2}>
              <RoundedButton
                variant="primary"
                withPadding
                withShadow
                onClick={redirectToCookies}
              >
                Configurar Cookies
              </RoundedButton>
            </Box>
          </>
        ) : (
          <RoundedButton
            variant="primary"
            withPadding
            withShadow
            onClick={() => handleNext()}
          >
            Finalizar
          </RoundedButton>
        )}
      </Box>
    </>
  )
}

export default Conclusion
